/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TicketDto } from '../../models/ticket-dto';

export interface TicketControllerFindAll$Params {

/**
 * 아동 ID
 */
  centerChildId?: string;
}

export function ticketControllerFindAll(http: HttpClient, rootUrl: string, params?: TicketControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TicketDto>>> {
  const rb = new RequestBuilder(rootUrl, ticketControllerFindAll.PATH, 'get');
  if (params) {
    rb.query('centerChildId', params.centerChildId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TicketDto>>;
    })
  );
}

ticketControllerFindAll.PATH = '/api/ticket';
